export const copyToClipboard = (value, setCopied) => {
    if (!navigator.clipboard) {
        console.error("Clipboard API no está disponible.");
        return;
    }
    navigator.clipboard.writeText(value)
        .then(() => {
            console.log("Texto copiado al portapapeles:", value);
            if (setCopied) setCopied(true);
            setTimeout(() => {
                if (setCopied) setCopied(false);
            }, 1500);
        })
        .catch((err) => {
            console.error("Error al copiar al portapapeles:", err);
        });
};


export const formatAmount = (value, separator = ',') => {
    if (!value) return "$0";

    const numericValue = value.toString().replace(/[^0-9.]/g, '');
    const [integerPart, decimalPart] = numericValue.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return (
        <span>
            ${formattedInteger}
            {decimalPart !== undefined && (
                <span style={{ fontSize: "0.75em", opacity: 0.8 }}>,{decimalPart}</span>
            )}
        </span>
    );
};

export const formatAmountForInput = (value, separator = '.') => {
    if (!value) return '';

    const numericValue = value.toString().replace(/[^0-9]/g, ''); // Mantener solo números
    const [integerPart, decimalPart] = numericValue.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);

    return decimalPart !== undefined ? `${formattedInteger},${decimalPart}` : `${formattedInteger}`;
};

export const formatPhoneNumber = (value) => {
    const numericValue = value.replace(/[^0-9]/g, '').slice(0, 11);

    if (numericValue.length <= 3) {
        return numericValue;
    } else if (numericValue.length <= 6) {
        return `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
    } else {
        return `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
    }
};

export const handlePhoneInputChange = (value, setState) => {
    const numericValue = value.replace(/[^0-9]/g, '').slice(0, 11);
    setState(numericValue);
};


export const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value.trim());
};

export const handleEmailChange = (value, setState, setError) => {
    const trimmedValue = value.trim();
    setState(trimmedValue);
    const isValid = validateEmail(trimmedValue);
    setError(!isValid);
    return isValid;
};
export const FormatMontoPSE = (monto, mostrarDecimales = false, separadorMiles = ",") => {
    if (monto === null || monto === undefined || monto === '' || isNaN(monto)) {
        monto = 0;
    }
    monto = Number(monto);
    const opciones = {
        minimumFractionDigits: mostrarDecimales ? 2 : 0,
        maximumFractionDigits: mostrarDecimales ? 2 : 0,
    };

    // Convertimos el número a string con formato en-US (miles con coma, decimales con punto)
    let formattedMonto = monto.toLocaleString('en-US', opciones);

    // Convertimos el separador de miles a punto (.) y el separador de decimales a coma (,)
    formattedMonto = formattedMonto.replace(/,/g, '_'); // Temporalmente sustituimos comas (miles) por un placeholder
    formattedMonto = formattedMonto.replace(/\./g, ','); // Convertimos punto decimal en coma
    formattedMonto = formattedMonto.replace(/_/g, '.'); // Restauramos los separadores de miles como puntos

    const [integerPart, decimalPart] = formattedMonto.split(',');

    return (
        <span>
            $ {integerPart}
            {decimalPart !== undefined && (
                <span style={{ fontSize: "0.75em", opacity: 0.8 }}>,{decimalPart}</span>
            )} {separadorMiles === '.' ? 'USD' : 'COP'}
        </span>
    );
};


export const bankList = [
    { label: "Bancolombia", value: 0 },
    { label: "Bogota", value: 1 },
    { label: "Davivienda", value: 2 },
    { label: "BBVA", value: 3 },
    { label: "Occidente", value: 4 },
    { label: "Colpatria", value: 5 },
    { label: "Popular", value: 6 },
    { label: "Helm", value: 7 },
    { label: "Agrario", value: 8 },
    { label: "BCSC", value: 9 },
    { label: "Citybank", value: 11 },
    { label: "Avvillas", value: 12 },
    { label: "Procredit", value: 13 },
    { label: "Pichincha", value: 14 },
    { label: "Bancoomeva", value: 15 },
    { label: "Santander", value: 16 },
    { label: "Falabella", value: 17 },
    { label: "Nequi", value: 18 },
    { label: "Daviplata", value: 19 },
    { label: "Finandina", value: 20 },
    { label: "Itau", value: 21 },
    { label: "Itau Corbanca", value: 22 },
    { label: "Lulo Bank", value: 23 },
    { label: "Coltefinanciera", value: 24 },
    { label: "UALA", value: 25 },
    { label: "Cooperativo Coopcentral", value: 26 },
    { label: "RappiPay", value: 28 },
    { label: "Cooperativa Financiera de Antioquia", value: 29 },
    { label: "Financiera Juriscoop SA", value: 30 },
    { label: "Confiar", value: 31 },
    { label: "Cootrafa Cooperativa Financiera", value: 32 },
    { label: "GNB Sudameris", value: 33 },
    { label: "Caja Social", value: 34 },
    { label: "NU", value: 35 },
];

// Función que retorna el label del banco según su identificador
export const getBankLabel = (bankId) => {
    const bank = bankList.find(b => b.value === bankId);
    return bank ? bank.label : bankId;
};



/* Formas de uso de las function
console.log(FormatMontoPSE(234542));             // "$234,542.00 COP" (por defecto con decimales)
console.log(FormatMontoPSE(234542, false));      // "$234,542 COP" (sin decimales)
console.log(FormatMontoPSE(234542, true, '.'));  // "$234.542 USD" (con separador punto y sin decimales)
console.log(FormatMontoPSE(0));                  // "$0.00 COP" (valor cero con decimales)
console.log(FormatMontoPSE(0, false, '.'));      // "$0 USD" (valor cero sin decimales y USD)
 */


/* Asi se usa la funcion para validad correos con InputLogin */
{/* <InputLogin 
    placeholder="ejemplo@correo.com" 
    value={correo}
    onChange={(e) => handleEmailChange(e, setCorreo, setCorreoError)} // Usar la lógica personalizada
    error={correoError}
/>
 */}

/* asi se utiliza para formatear numeros de telefono usando el InputLogin */

{/* <InputLogin 
    placeholder='Número teléfono' 
    value={phone}
    onChange={(e) => handlePhoneInputChange(e, setPhone)} 
    error={phoneError} 
    numericOnly={true}
    formatValue={formatPhoneNumber} 
/>
 */}

/**
 * Capitaliza el nombre completo de una persona
 * @param {string} fullName - Nombre completo (ej: "franco niebles")
 * @returns {string} - Nombre capitalizado (ej: "Franco Niebles")
 */
export const capitalizeFullName = (fullName) => {
    if (!fullName || typeof fullName !== 'string') {
        return fullName;
    }

    return fullName
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

/**
 * Capitaliza solo la primera letra de cada palabra
 * @param {string} text - Texto a capitalizar
 * @returns {string} - Texto con primera letra capitalizada
 */
export const capitalizeWords = (text) => {
    if (!text || typeof text !== 'string') {
        return text;
    }

    return text
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};